(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProduct(root) {
      if (!root || root.dataset.productInitialized === 'true') return;
      root.dataset.productInitialized = 'true';

      var variantsNode = root.parentElement.querySelector('[data-product-variants]');
      var variantSelect = root.querySelector('[data-variant-select]');
      var quantityInput = root.querySelector('[data-quantity-input]');
      var addButton = root.querySelector('[data-add-to-cart]');
      var productForm = root.querySelector('.asc-product-form');
      var directCheckoutButtons = Array.prototype.slice.call(root.querySelectorAll('[data-direct-checkout-button]'));
      var checkoutError = root.querySelector('[data-checkout-error]');
      var stickyButton = document.querySelector('[data-sticky-add]');
      var stickyBar = document.querySelector('[data-sticky-bar]');
      var productPrice = root.querySelector('[data-product-price]');
      var stickyPrice = document.querySelector('[data-sticky-price]');
      var comparePrice = root.querySelector('[data-compare-price]');
      var stockStatus = root.querySelector('[data-stock-status]');
      var sku = document.querySelector('[data-current-sku]');
      var variants = [];

      if (variantsNode) {
        try { variants = JSON.parse(variantsNode.textContent); } catch (error) { variants = []; }
      }

      function setButtonState(button, available, availableLabel) {
        if (!button) return;
        button.disabled = !available;
        button.classList.toggle('is-disabled', !available);
        button.textContent = available ? (availableLabel || 'Add to cart') : 'Sold out';
      }

      function setDirectCheckoutState(available) {
        directCheckoutButtons.forEach(function (button) {
          setButtonState(button, available, button.dataset.availableLabel);
          button.removeAttribute('aria-busy');
        });
      }

      function selectedVariantIsAvailable() {
        if (!variantSelect) return !addButton || !addButton.disabled;
        var selectedId = String(variantSelect.value);
        var selectedVariant = variants.find(function (item) { return String(item.id) === selectedId; });
        return Boolean(selectedVariant && selectedVariant.available);
      }

      function showCheckoutError(message) {
        if (!checkoutError) return;
        checkoutError.textContent = message;
        checkoutError.hidden = false;
      }

      function clearCheckoutError() {
        if (!checkoutError) return;
        checkoutError.textContent = '';
        checkoutError.hidden = true;
      }

      function proceedToCheckout() {
        if (!productForm || !selectedVariantIsAvailable()) return;
        clearCheckoutError();
        sanitizeQuantity();
        var shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        var formData = new FormData(productForm);
        var selectedVariantId = String(formData.get('id') || '');
        var requestedQuantity = parseInt(String(formData.get('quantity') || '1'), 10) || 1;

        function cartContainsSelectedVariant(cart) {
          return Boolean(cart && Array.isArray(cart.items) && cart.items.some(function (item) {
            return String(item.variant_id || item.id) === selectedVariantId;
          }));
        }

        function fetchCurrentCart() {
          return fetch(shopRoot + 'cart.js', {
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin'
          })
            .then(function (response) {
              if (!response.ok) return null;
              return response.json().catch(function () { return null; });
            })
            .catch(function () { return null; });
        }

        function addSelectedItem() {
          return fetch(productForm.action, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: formData
          })
            .then(function (response) {
              return response.json().catch(function () { return {}; }).then(function (data) {
                if (response.ok) return { destination: 'checkout' };

                var message = data.description || data.message || 'This item could not be added to checkout.';
                if (response.status !== 422) throw new Error(message);

                return fetchCurrentCart().then(function (cart) {
                  if (cartContainsSelectedVariant(cart)) return { destination: 'cart' };
                  throw new Error(message);
                });
              });
            });
        }

        directCheckoutButtons.forEach(function (button) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        });

        var destinationPromise = requestedQuantity === 1
          ? fetchCurrentCart().then(function (cart) {
              if (cartContainsSelectedVariant(cart)) return { destination: 'cart' };
              return addSelectedItem();
            })
          : addSelectedItem();

        destinationPromise
          .then(function (result) {
            window.location.assign(shopRoot + result.destination);
          })
          .catch(function (error) {
            setDirectCheckoutState(selectedVariantIsAvailable());
            showCheckoutError(error.message || 'Checkout could not be opened. Please try again.');
          });
      }

      if (productForm) {
        productForm.addEventListener('submit', function (event) {
          var submitter = event.submitter;
          if (!submitter || !submitter.matches('[data-direct-checkout-button]')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          proceedToCheckout();
        }, true);
      }

      function sanitizeQuantity() {
        if (!quantityInput) return 1;
        var quantity = parseInt(quantityInput.value, 10) || 1;
        var max = parseInt(quantityInput.getAttribute('max'), 10);
        quantity = Math.max(1, quantity);
        if (!isNaN(max)) quantity = Math.min(max, quantity);
        quantityInput.value = quantity;
        var decrease = root.querySelector('[data-quantity-action="decrease"]');
        var increase = root.querySelector('[data-quantity-action="increase"]');
        if (decrease) decrease.disabled = quantity <= 1;
        if (increase) increase.disabled = !isNaN(max) && quantity >= max;
        return quantity;
      }

      function updateVariant(variant) {
        if (!variant) return;
        setButtonState(addButton, variant.available);
        setButtonState(stickyButton, variant.available);
        setDirectCheckoutState(variant.available);
        clearCheckoutError();
        if (productPrice) productPrice.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;
        if (comparePrice) {
          comparePrice.hidden = !variant.hasComparePrice;
          comparePrice.textContent = variant.hasComparePrice ? variant.compareAtPrice : '';
        }
        if (stockStatus) {
          stockStatus.textContent = variant.available ? 'In stock' : 'Sold out';
          stockStatus.classList.toggle('asc-badge--trust', variant.available);
          stockStatus.classList.toggle('asc-badge--warning', !variant.available);
        }
        if (sku) sku.textContent = variant.sku || 'Not assigned';
        if (quantityInput) {
          if (variant.inventoryLimited && variant.inventoryQuantity > 0) {
            quantityInput.setAttribute('max', String(variant.inventoryQuantity));
          } else {
            quantityInput.removeAttribute('max');
          }
          quantityInput.disabled = !variant.available;
          sanitizeQuantity();
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          var selectedId = String(variantSelect.value);
          var variant = variants.find(function (item) { return String(item.id) === selectedId; });
          updateVariant(variant);
        });
      }

      root.querySelectorAll('[data-quantity-action]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!quantityInput) return;
          var quantity = sanitizeQuantity();
          quantityInput.value = button.dataset.quantityAction === 'increase' ? quantity + 1 : quantity - 1;
          sanitizeQuantity();
        });
      });
      if (quantityInput) {
        quantityInput.addEventListener('change', sanitizeQuantity);
        quantityInput.addEventListener('input', sanitizeQuantity);
        sanitizeQuantity();
      }

      if (addButton && stickyBar && 'IntersectionObserver' in window) {
        var purchaseObserver = new IntersectionObserver(function (entries) {
          stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
        }, { threshold: 0.2 });
        purchaseObserver.observe(addButton);
      }

      var media = Array.prototype.slice.call(root.querySelectorAll('[data-product-media]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-product-thumb]'));
      var gallery = root.querySelector('[data-product-gallery]');
      var count = root.querySelector('[data-gallery-count]');
      var imageDialog = root.querySelector('[data-image-dialog]');
      var dialogImage = root.querySelector('[data-image-dialog-image]');
      var dialogCaption = root.querySelector('[data-image-dialog-caption]');
      var dialogClose = root.querySelector('[data-image-dialog-close]');
      var dialogOpener = null;
      var currentMedia = 0;
      var touchStartX = 0;

      function showMedia(index) {
        if (!media.length) return;
        currentMedia = (index + media.length) % media.length;
        media.forEach(function (item, itemIndex) {
          var active = itemIndex === currentMedia;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        thumbs.forEach(function (thumb, itemIndex) {
          thumb.setAttribute('aria-current', itemIndex === currentMedia ? 'true' : 'false');
        });
        if (count) count.textContent = 'Image ' + (currentMedia + 1) + ' of ' + media.length;
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () { showMedia(index); });
      });
      var previous = root.querySelector('[data-gallery-previous]');
      var next = root.querySelector('[data-gallery-next]');
      if (previous) previous.addEventListener('click', function () { showMedia(currentMedia - 1); });
      if (next) next.addEventListener('click', function () { showMedia(currentMedia + 1); });
      if (gallery && media.length > 1) {
        gallery.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') showMedia(currentMedia - 1);
          if (event.key === 'ArrowRight') showMedia(currentMedia + 1);
        });
        gallery.addEventListener('touchstart', function (event) { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
        gallery.addEventListener('touchend', function (event) {
          var distance = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(distance) < 45) return;
          showMedia(distance > 0 ? currentMedia - 1 : currentMedia + 1);
        }, { passive: true });
      }

      root.querySelectorAll('[data-open-image]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!imageDialog || !dialogImage) return;
          dialogOpener = button;
          dialogImage.src = button.dataset.imageSrc || '';
          dialogImage.alt = button.dataset.imageAlt || '';
          if (dialogCaption) dialogCaption.textContent = button.dataset.imageCaption || '';
          if (typeof imageDialog.showModal === 'function') {
            imageDialog.showModal();
          } else {
            imageDialog.setAttribute('open', '');
          }
        });
      });

      function closeImageDialog() {
        if (!imageDialog) return;
        if (typeof imageDialog.close === 'function') {
          imageDialog.close();
        } else {
          imageDialog.removeAttribute('open');
        }
      }

      if (dialogClose) dialogClose.addEventListener('click', closeImageDialog);
      if (imageDialog) {
        imageDialog.addEventListener('click', function (event) {
          if (event.target === imageDialog) closeImageDialog();
        });
        imageDialog.addEventListener('close', function () {
          if (dialogImage) dialogImage.removeAttribute('src');
          if (dialogOpener) dialogOpener.focus();
        });
      }
    }

    function initAllProducts() {
      document.querySelectorAll('[data-product-root]').forEach(initProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllProducts, { once: true });
    } else {
      initAllProducts();
    }
    document.addEventListener('shopify:section:load', initAllProducts);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-countdown-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shopforge-countdown')) {
    customElements.define('shopforge-countdown', class extends HTMLElement {
      connectedCallback() {
        const target = Date.parse(this.dataset.end || '');
        const output = this.querySelector('[data-countdown-output]');
        if (!output || Number.isNaN(target)) return;
        const render = () => {
          const distance = Math.max(0, target - Date.now());
          const days = Math.floor(distance / 86400000);
          const hours = Math.floor((distance % 86400000) / 3600000);
          const minutes = Math.floor((distance % 3600000) / 60000);
          output.textContent = distance ? `${days}d ${hours}h ${minutes}m` : 'Now available';
          if (!distance && this.timer) window.clearInterval(this.timer);
        };
        render();
        this.timer = window.setInterval(render, 60000);
      }
      disconnectedCallback() { if (this.timer) window.clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
